import { useState } from 'react';
import { exportAllowanceEvidence, listSubmittedPackages } from '../../../engine/etsRegistryAdapter';
import LoadingSpinner from '../components/common/LoadingSpinner';
import ErrorBanner from '../components/common/ErrorBanner';

export function ETSBridge() {
  const [companyId, setCompanyId] = useState('demo');
  const [certs, setCerts] = useState('1,2');
  const [rows, setRows] = useState(() => listSubmittedPackages());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const submit = () => {
    setLoading(true);
    setError(null);
    try {
      exportAllowanceEvidence(companyId, certs.split(',').map(s=>s.trim()).filter(Boolean));
      setRows(listSubmittedPackages());
    } catch (e) {
      const error = e instanceof Error ? e : new Error('Failed to export allowance evidence');
      setError(error);
      console.error('ETS Bridge export failed:', e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-3">
      <div className="font-orbitron text-evat-gold">ETS Registry Bridge</div>
      <div className="text-xs text-yellow-400">NOT OFFICIAL ETS CHANNEL</div>
      
      <ErrorBanner error={error} onRetry={submit} showRetry={!!error} />
      
      {loading && <LoadingSpinner size="sm" text="Exporting evidence..." />}
      
      <div className="flex gap-2 text-sm">
        <input
          value={companyId}
          onChange={(e)=>setCompanyId(e.target.value)}
          disabled={loading}
          className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 disabled:opacity-50"
        />
        <input
          value={certs}
          onChange={(e)=>setCerts(e.target.value)}
          disabled={loading}
          className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 disabled:opacity-50"
        />
        <button
          onClick={submit}
          disabled={loading}
          className="px-3 py-1 rounded border border-evat-neon text-evat-neon hover:shadow-neon disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? 'Exporting...' : 'Export Evidence'}
        </button>
      </div>
      <div className="border border-neutral-700 rounded p-2 text-xs max-h-64 overflow-auto">
        {rows.map(r => (<div key={r.id} className="flex justify-between"><span>{r.id}</span><span>{r.status}</span><span>{new Date(r.createdAt).toLocaleString()}</span></div>))}
        {rows.length===0 && <div className="text-neutral-500">No packages</div>}
      </div>
    </div>
  );
}

export default ETSBridge;














